module.exports = __webpack_public_path__ + "9c43834b0c83ec066b8f152ba662a784.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-volleyball-s.png
// module id = 2476
// module chunks = 0